import React from 'react'
import img1 from "../assests/why-choose-img1.png";
import img2 from "../assests/why-choose-img2.png";
import img3 from "../assests/why-choose-img3.png";
import img4 from "../assests/why-choose-img4.png";
import img5 from "../assests/why-choose-img5.png";
import img6 from "../assests/why-choose-img6.png";
import img7 from "../assests/why-choose-img7.png";
import img8 from "../assests/why-choose-img8.png";
import img9 from "../assests/why-choose-img9.png";
import img10 from "../assests/why-choose-img10.png";
import img11 from "../assests/why-choose-img11.png";
import img12 from "../assests/why-choose-img12.png";


const WhyPremisin = () => {
  return (
    <>
      <section id="why-choose">
        <div className="container text-center">
          <div className="row">
            <div className="col-12">
              <h2 className="h1">Why Choose Premisin?</h2>
              <p>
                All-Inclusive Services: We take care of everything –
                electricity, cleaning, maintenance, internet, and more – so you
                can focus on your work hassle-free.
              </p>
              <p>
                Unleash Your Potential: Our thoughtfully curated workspaces are
                tailored to support your business growth and elevate your
                professional journey.
              </p>
              <p>
                Amenities That Inspire: Our premium amenities include high-speed
                internet, meeting rooms, refreshment areas, and more.
              </p>
              <p>
                Location Advantage: Conveniently located in the heart of Raipur,
                our spaces offer easy access to key areas, transportation, and
                entertainment hubs.
              </p>
              <div className="u-h-4 u-w-50 bg-primary rounded mt-4 u-mb-20 mx-auto"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img1}
                  data-original={img1}
                  alt="Premisin"
                />
                <h4 className="mt-3">Air Condition</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img2}
                  data-original={img2}
                  alt="Premisin"
                />
                <h4 className="mt-3">Internet</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img3}
                  data-original={img3}
                  alt="Premisin"
                />
                <h4 className="mt-3">Power Backup</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img4}
                  data-original={img4}
                  alt="Premisin"
                />
                <h4 className="mt-3">Electricity</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img5}
                  data-original={img5}
                  alt="Premisin"
                />
                <h4 className="mt-3">Housekeeping</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img6}
                  data-original={img6}
                  alt="Premisin"
                />
                <h4 className="mt-3">Security</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img7}
                  data-original={img7}
                  alt="Premisin"
                />
                <h4 className="mt-3">Club Area</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img8}
                  data-original={img8}
                  alt="Premisin"
                />
                <h4 className="mt-3">Pantry</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img9}
                  data-original={img9}
                  alt="Premisin"
                />
                <h4 className="mt-3">Ready to Move</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img10}
                  data-original={img10}
                  alt="Premisin"
                />
                <h4 className="mt-3">Lift</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img11}
                  data-original={img11}
                  alt="Premisin"
                />
                <h4 className="mt-3">CCTV</h4>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-4">
              <div className="bg-white box-shadow-v2 rounded py-4">
                <img
                  className="lazyloadimg"
                  src={img12}
                  data-original={img12}
                  alt="Premisin"
                />
                <h4 className="mt-3">Parking</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default WhyPremisin